module.exports = __webpack_public_path__ + "static/media/Contact.62e036a9.jpg";